<template>
  <div>
    <v-combobox
      :value="tags"
      @input="handleChangeTags"
      :filter="handleFilterTag"
      :hide-no-data="!tagSearch"
      :items="items"
      :search-input.sync="tagSearch"
      hide-selected
      label="Search for an option"
      multiple
      small-chips
      solo
      :item-value="itemValue"
      :item-text="itemText"
    >
      <template v-slot:no-data>
        <v-list-tile>
          <span class="subheading">Create</span>
          <v-chip :color="`primary lighten-3`" label small>{{ tagSearch }}</v-chip>
        </v-list-tile>
      </template>
      <template v-slot:selection="{ item, parent, selected }">
        <v-chip
          v-if="item === Object(item)"
          :color="`primary lighten-3`"
          :selected="selected"
          label
          small
        >
          <span class="pr-2">{{ item && item.name }}</span>
          <v-icon small @click="parent.selectItem(item)">close</v-icon>
        </v-chip>
        <v-chip
          v-else-if="typeof item == 'string'"
          :color="`primary lighten-3`"
          :selected="selected"
          label
          small
        >
          <span class="pr-2">{{ item }}</span>
          <v-icon small @click="parent.selectItem(item)">close</v-icon>
        </v-chip>
      </template>
      <template v-slot:item="{ index, item }">
        <v-list-tile-content>
          <v-text-field
            v-if="tagEditing && tagEditing == item"
            v-model="tagEditing[itemValue]"
            autofocus
            flat
            background-color="transparent"
            hide-details
            solo
            @keyup.enter="handleEditTag(index, item)"
          ></v-text-field>
          <v-chip
            v-else-if="itemValue && item && Object.hasOwnProperty.call(item, itemValue)"
            :color="`primary lighten-3`"
            label
            small
            >{{ item[itemValue] }}</v-chip
          >
        </v-list-tile-content>
        <v-spacer></v-spacer>
        <v-list-tile-action @click.stop style="display: flex; flex-direction: row">
          <v-btn icon @click.stop.prevent="handleDeleteTag(item)">
            <v-icon>delete</v-icon>
          </v-btn>
          <v-btn icon @click.stop.prevent="handleEditTag(index, item)">
            <v-icon>{{ tagEditing !== item ? 'edit' : 'check' }}</v-icon>
          </v-btn>
        </v-list-tile-action>
      </template>
    </v-combobox>
  </div>
</template>

<script>
import ticketApi from '@/api/ticket'
import { handleResponse, handleApiError } from '@/api/util'
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      default: null
    },
    items: {
      default: []
    },
    filter: {
      default: undefined
    },
    itemValue: {
      default: 'name'
    },
    itemText: {
      default: 'name'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  data() {
    return {
      tags: [],
      tagEditing: null,
      tagSearch: null,
      index: null
    }
  },
  mounted() {
    this.tags = this.value
  },
  methods: {
    async handleDeleteTag(val) {
      try {
        const result = await this.$swal.fire({
          title: this.$t('Do you want to delete this?'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        if (result.value) {
          this.$store.dispatch('loading')
          if (val) {
            const response = await ticketApi.deleteTag({
              pageid: this.selectedBot.pageid,
              data: {
                id: val.id
              }
            })
            await handleResponse(response)
            const tags = this.items.filter((tag) => tag.id != val.id)
            this.$store.commit('SET_TICKET_TAGS_FULL', tags)
            this.$store.dispatch('clear_loading')
            return true
          }
          this.$emit('onDirty')
        }
      } catch (error) {
        handleApiError(error)
        this.$store.dispatch('clear_loading')
        return false
      }
    },
    handleChangeTags(val) {
      this.tags = val
      this.$emit('input', val)
    },
    async handleEditTag(index, item) {
      if (!this.tagEditing) {
        this.tagEditing = item
        this.index = index
      } else {
        //save tag

        this.$emit('onDirty')
        const result = await this.handleEditTicketTag(item, this.tagEditing)
        if (result) {
          //clear tag
          const tagIndex = this.items.findIndex((el) => el.id != item.id)
          if (tagIndex != -1) {
            const tags = this.items
            tags[tagIndex] = this.tagEditing
            this.$store.commit('SET_TICKET_TAGS_FULL', tags)
          }
          this.tagEditing = null
          this.index = -1
        }
      }
    },

    async handleEditTicketTag(item, newVal) {
      try {
        const tag = this.items.find((tag) => {
          return (
            tag && item && tag[this.itemValue].toLowerCase() == item[this.itemValue].toLowerCase()
          )
        })

        if (tag && newVal) {
          const response = await ticketApi.putEditTicketTag({
            data: {
              pageid: this.selectedBot.pageid,
              id: tag.id,
              ticket_tag: newVal[this.itemValue]
            }
          })
          await handleResponse(response)
          return true
        }
      } catch (error) {
        handleApiError(error)
        return false
      }
    },
    handleFilterTag(item, queryText, itemText) {
      if (this.filter) {
        return this.filter(item, queryText, itemText)
      }
      if (item.header) return false

      const hasValue = (val) => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    }
  },
  watch: {
    tags(val, prev) {
      if (val.length === prev.length) return

      this.$emit('onDirty')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket/TagManagement.vue